import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
// import { InputField } from "../../../Components/formElements/InputField";
// import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/SupplierConstants";
import {
  addInvoiceDetailNumber,
  getInvoiceList,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import SupplierConstants from "../../../../common/SupplierConstants";

const NonPoInvoiceList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Non PO Invoice");
  let userInfo = useSelector((state) => state?.user?.data);

  let invoiceListData = useSelector((state) => state?.purchasing?.invoice); // get invoiceListData from Store

  let invoiceListDataTable = useSelector(
    (state) => state?.purchasing?.invoice?.pagination,
  ); // invoiceListData Details from Store

  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.INVOICE?.module,
  ); // config Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const detailedPageInvoice = (invoiceNumber) => {
    // console.log("invoiceNumber", invoiceNumber);
    dispatch(addInvoiceDetailNumber(invoiceNumber));
    navigate(Constants.POCOLLABRATION_NON_PO_INVOICE_DETIALS);
  };

  const [chatId, setChatId] = useState(null);

  // Invoice Table Col
  const invoiceDataColumns = [
    /*    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5 " />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    }, */
    {
      name: "Invoice Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "SAP Document Nr",
      selector: (row) => row.sapDocumentNumber,
      cell: (row) => (
        <>       
        <TableStatusField status={"SAPDOC"}  value={row.sapDocumentNumber}/>
        </>

      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.invoiceStatusHeader}
    //       </span>
    //     </>
    //   ),
    //   width: "180px",
    // },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Status",
      selector: (row) => row.invoiceStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.invoiceStatusHeader} />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate,
      sortable: true,
      width: "130px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.vendorTotalInvoiceValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Currency",
      selector: (row) => row.vendorInvoiceCurrency,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorInvoiceCurrency} </p>
          <p className="m-0 p-0">{row.currency} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    // {
    //   name: "PO/SA Number",
    //   selector: (row) => row.purchasingDocumentNr,
    //   cell: (row) => (
    //     <button
    //       className="btnInfo"
    //       onClick={() => detailedPagePO(row.purchasingDocumentNr)}
    //     >
    //       {row.purchasingDocumentNr}
    //     </button>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "PO/SA Date/Time",
      selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Invoice",
      selector: (row) => row.sapInvoiceNumber || row.invoiceNumber,
      cell: (row) => (
        <span>{row.sapInvoiceNumber || row.invoiceNumber || "--"}</span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "SAP Status",
      selector: (row) => row.sapStatus,
      cell: (row) => <span>{row.sapStatus || "--"}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Posted On",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "GRN Value",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "GRN Number",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "GRN Value",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Cancelled INV Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
  ];

  // Invoice Item Table Col
  const lineItemColInfo = [
    {
      name: "Inv Item Nr",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    // {
    //   name: "Material Desc",
    //   cell: (row) => <span>{row.materialDescription} </span>,
    //   width: "220px",
    // },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Invoice Quantity",
      cell: (row) => <span>{row.invoiceQuantity} </span>,
      width: "220px",
    },
    {
      name: "Item Net Value",
      cell: (row) => <span>{row.totalPrice} </span>,
      width: "220px",
    },
    {
      name: "Item Tax Value",
      cell: (row) => <span>{row.invItemTaxValue} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handlePageChange = (page) => {
    const isAdmin = userInfo?.roles?.some((role) => role.roleId === "ADMIN");

    let obj = {
      queryName: "getInvoiceListVendorNonPo",
      module: "INVOICE",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };

    if (!isAdmin) {
      obj.rowFilter = {
        vendorCode: JSON.parse(localStorage.getItem("userData"))?.data?.userId,
      };
    }

    dispatch(getInvoiceList(obj));
    setData(invoiceListData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    const isAdmin = userInfo?.roles?.some((role) => role.roleId === "ADMIN");

    let obj = {
      queryName: "getInvoiceListVendorNonPo",
      module: "INVOICE",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };

    if (!isAdmin) {
      obj.rowFilter = {
        vendorCode: JSON.parse(localStorage.getItem("userData"))?.data?.userId,
      };
    }

    dispatch(getInvoiceList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    const isAdmin = userInfo?.roles?.some((role) => role.roleId === "ADMIN");

    let obj = {
      queryName: "getInvoiceListVendorNonPo",
      module: "INVOICE",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };

    if (!isAdmin) {
      obj.rowFilter = {
        vendorCode: JSON.parse(localStorage.getItem("userData"))?.data?.userId,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getInvoiceList(obj));
  };

  const loadInitialPOData = async () => {
    const isAdmin = userInfo?.roles?.some((role) => role.roleId === "ADMIN");

    let obj = {
      queryName: "getInvoiceListVendorNonPo",
      module: "INVOICE",
      page: 1,
      per_page: 10,
    };

    if (!isAdmin) {
      obj.rowFilter = {
        vendorCode: JSON.parse(localStorage.getItem("userData"))?.data?.userId,
      };
    }

    dispatch(getInvoiceList(obj));
  };

  useEffect(() => {
    loadInitialPOData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);

  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  // const [getSelectedRows, setSelectedRows] = useState([]);

  //createNonPoInvoice
  const createNonPoInvoice = () => {
    navigate(SupplierConstants.POCOLLABRATION_NON_PO_INVOICE_CREATION);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Non PO Invoice</h2>
                <p className="subText">Lists of Non PO Invoice and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IN</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Non PO Invoice List</span>
                      <span className="subHeaderTitle">
                        View of Non PO Invoice and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6} className="d-flex gap-1">
                        <button
                          className="btnTable"
                          onClick={createNonPoInvoice}
                        >
                          <i class="bi bi-receipt"></i> Post
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn columnIndexes={[1]} leftOffsets={[]} />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={invoiceDataColumns}
                          data={invoiceListData?.data}
                          progressPending={invoiceListData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={invoiceListDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Invoice"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        // selectedrow={getSelectedRows}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default NonPoInvoiceList;
